import { createFileRoute, redirect } from '@tanstack/react-router'

// The shared route registry (routes.tsx's SETTINGS entry) has always pointed the
// sidebar's "Settings" link here, but no page was ever built at this path — it 404'd
// ("Not Found") for every admin who clicked it. Site Settings (/site) is the real,
// fully-built settings page (General/Social/Contact/Shipping/Theme); this just gets a
// real admin to the real page instead of a dead link.
export const Route = createFileRoute('/(admin)/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/site' })
  },
})
